




import { defineComponent, PropType } from '@nuxtjs/composition-api';
import {
  IUCFeatureListItem,
  IUCFeatureListSize,
} from '@shared/components/@organisms/UCFeatureList/types';
import UCFeatureList from '@shared/components/@organisms/UCFeatureList/UCFeatureList.vue';

import { transformCustomerValuePropositions } from './helpers';
import { ISBCustomerProposition } from './types';

export default defineComponent({
  name: 'UCStoryblokCustomerValueProposition',
  components: {
    UCFeatureList,
  },
  props: {
    size: {
      type: String as PropType<IUCFeatureListSize>,
      default: 'compact',
    },
    // eslint-disable-next-line vue/prop-name-casing
    customer_value_propositions: {
      type: Array as PropType<ISBCustomerProposition[]>,
      default: () => [],
    },
  },
  computed: {
    transformedSize(): IUCFeatureListSize {
      return !this.size ? 'compact' : this.size;
    },
    transformedItems(): IUCFeatureListItem[] {
      return transformCustomerValuePropositions(this.customer_value_propositions);
    },
  },
});
